export const ApiDomain = "https://moto.hashspace.cn";
export const SiteName = "61摩托";

export function currentTitle(title) {
  if (typeof title === 'undefined' || title.length === 0) {
    return SiteName;
  }

  return title + ' | ' + SiteName;
}